import React from 'react';

import Location from './partials/location/Location';
import User from './partials/user/User';
import Nav from './partials/nav/Nav';

import * as css from './css/header';
import {observer} from 'mobx-react';
import useMyStores from "hooks/useMyStores";

const Header = ({className}) => {

    const {menu} = useMyStores()

    return (
        <css.Header className={className}>
            <css.Container is1200={menu.is1200}>
                <css.Location as={Location}/>
                <css.User as={User}/>
                <css.Nav as={Nav}/>
            </css.Container>
        </css.Header>
    );

}

export default observer(Header);
